var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import * as React from 'react';
import { genId } from "../../utils";
import { Box } from '../Box';
var NotificationSingleton = null;
export var addNotification = function (notification) {
    if (NotificationSingleton === null) {
        throw new Error('No NotificationTray component is mounted in this application');
    }
    NotificationSingleton.add(notification);
};
var NotificationTray = /** @class */ (function (_super) {
    __extends(NotificationTray, _super);
    function NotificationTray() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.addNotification = function (notification) {
            _this.setState(function (prevState) { return ({
                notifications: __spread(prevState.notifications, [
                    { notification: notification, id: genId('notify') }
                ])
            }); });
        };
        _this.state = {
            notifications: [],
            add: _this.addNotification
        };
        _this.handleDismiss = function (id) { return function () {
            _this.setState(function (prevState) { return ({
                notifications: prevState.notifications.filter(function (i) { return i.id !== id; })
            }); });
        }; };
        return _this;
    }
    NotificationTray.prototype.componentDidMount = function () {
        if (NotificationSingleton !== null) {
            throw new Error('Unable to load two NotificationTrays in the same application');
        }
        NotificationSingleton = this.state;
    };
    NotificationTray.prototype.componentWillUnmount = function () {
        NotificationSingleton = null;
    };
    NotificationTray.prototype.render = function () {
        var _this = this;
        return (React.createElement(Box, { lss: __assign({ zIndex: 'notification', bottom: 'xxl', left: 'xl', maxWidth: 'md', position: 'fixed' }, this.props.lss) }, this.state.notifications.map(function (_a) {
            var notification = _a.notification, id = _a.id;
            return React.cloneElement(notification, {
                key: id,
                dismissable: true,
                onDismiss: _this.handleDismiss(id)
            });
        })));
    };
    return NotificationTray;
}(React.Component));
export { NotificationTray };
//# sourceMappingURL=NotificationTray.js.map